import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@mui/material";
import Tooltip from "./CopyableTooltip";

/**
 * ActionIconButton
 * 
 * Un componente condiviso per i bottoni di azione (es. tabelle, card mobile).
 * Incapsula il Tooltip e gestisce logicamente il colore, le dimensioni
 * e lo stato disabilitato per garantire consistenza nell'interfaccia.
 */
const ActionIconButton = ({
  onClick,
  disabled,
  icon: Icon,
  color = "#0b3d87",
  mobileBgColor = "transparent",
  isMobile = false,
  title,
}) => {
  const getBackgroundColor = () => {
    if (!isMobile) return "transparent";
    return disabled ? "#f5f5f5" : mobileBgColor;
  };

  const button = (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        color: disabled ? "gray" : color,
        backgroundColor: getBackgroundColor(),
      }}
      size={isMobile ? "small" : "medium"}
    >
      <Icon fontSize={isMobile ? "small" : "medium"} />
    </IconButton>
  );

  return title && !isMobile ? (
    <Tooltip title={title} arrow copyable={false}>
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

ActionIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.elementType.isRequired,
  color: PropTypes.string,
  mobileBgColor: PropTypes.string,
  isMobile: PropTypes.bool,
  title: PropTypes.string,
};

export default ActionIconButton;
